import { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '@iconify/react'

// antd
import { Button } from 'antd'

// slices
import { changeTab, profileState } from '../profile.slice'

// profile sections
import EducationSummaryContent from '../education/educationSummaryContent'
import CertificatesSummaryContent from '../certificates/certificatesSummaryContent'
import ExperienceSummaryContent from '../experience/experienceSummaryContent'
import ProjectsSummaryContent from '../projects/projectsSummaryContent'
import OverviewSummaryContent from '../summary/overviewSummaryContent'
import VideosSummaryContent from '../videos/videosSummaryContent'

import styles from './tab.section.module.css'

const SECTION_META = [
    {
        key: 'summary',
        title: 'Summary',
        icon: 'mdi:text-box-outline',
        description: 'Please add your short description to the profile.',
    },
    {
        key: 'education',
        title: 'Education',
        icon: 'mdi:school-outline',
        description: 'Please add your qualification details to the profile.',
    },
    {
        key: 'certificates',
        title: 'Certificates',
        icon: 'mdi:certificate-outline',
        description:
            'Please add all the certificates to show the achievements.',
    },
    {
        key: 'experience',
        title: 'Experience',
        icon: 'mdi:briefcase-outline',
        description: 'Please add your experience details.',
    },
    {
        key: 'projects',
        title: 'Projects',
        icon: 'mdi:folder-outline',
        description: 'Please add all the projects done by you.',
    },
    {
        key: 'videos',
        title: 'Videos',
        icon: 'mdi:video-outline',
        description:
            'Please add your video here as per the preference to the profile.',
    },
]

function OverviewTabSection() {
    const dispatch = useDispatch()
    const { profileData, status } = useSelector(profileState)

    function checkTabKey(key) {
        switch (key) {
            case 'summary':
                return (
                    <OverviewSummaryContent
                        contentData={profileData}
                        keyText={key}
                    />
                )

            case 'education':
                return (
                    <EducationSummaryContent
                        contentData={profileData?.data[key].slice(0, 2)}
                    />
                )

            case 'certificates':
                return (
                    <CertificatesSummaryContent
                        contentData={profileData?.data[key].slice(0, 2)}
                    />
                )

            case 'experience':
                return (
                    <ExperienceSummaryContent
                        contentData={profileData?.data[key].slice(0, 2)}
                    />
                )

            case 'projects':
                return (
                    <ProjectsSummaryContent
                        contentData={profileData?.data[key].slice(0, 4)}
                    />
                )

            case 'videos':
                return (
                    <VideosSummaryContent
                        contentData={profileData?.data[key].slice(0, 4)}
                    />
                )

            default:
                return null
        }
    }

    const hasSectionData = (key) => {
        if (!profileData?.data) return false
        if (key === 'summary') {
            return (
                profileData.data[key] &&
                Object.keys(profileData.data[key])?.length > 0
            )
        }
        return profileData.data[key]?.length > 0
    }

    return (
        <div className={styles.overviewRoot}>
            {SECTION_META.map((content) => {
                const loaded = Object.keys(profileData || {}).length !== 0
                const showContent =
                    loaded && status === 'loaded' && hasSectionData(content.key)

                return (
                    <Fragment key={content.key}>
                        <section className={styles.sectionCard}>
                            {content.key !== 'summary' && (
                                <div className={styles.sectionHeader}>
                                    <div className={styles.sectionTitleWrap}>
                                        <span className={styles.sectionIcon}>
                                            <Icon
                                                icon={content.icon}
                                                width={18}
                                                height={18}
                                            />
                                        </span>
                                        <h4 className={styles.sectionTitle}>
                                            {content.title}
                                        </h4>
                                    </div>
                                    {showContent && (
                                        <Button
                                            type="text"
                                            className={styles.viewMoreBtn}
                                            onClick={() => {
                                                if (
                                                    content.key ===
                                                    'certificates'
                                                ) {
                                                    dispatch(
                                                        changeTab('education')
                                                    )
                                                } else {
                                                    dispatch(
                                                        changeTab(content.key)
                                                    )
                                                }
                                            }}
                                        >
                                            View more
                                            <Icon
                                                icon="mdi:arrow-right"
                                                width={14}
                                                height={14}
                                            />
                                        </Button>
                                    )}
                                </div>
                            )}

                            {showContent ? (
                                checkTabKey(content.key)
                            ) : status === 'loaded' ? (
                                <div className={styles.emptyBlock}>
                                    <span className={styles.emptyIcon}>
                                        <Icon
                                            icon={content.icon}
                                            width={18}
                                            height={18}
                                        />
                                    </span>
                                    <div className={styles.emptyCopy}>
                                        <p className={styles.emptyTitle}>
                                            No {content.title.toLowerCase()}{' '}
                                            added
                                        </p>
                                        <p className={styles.emptyText}>
                                            {content.description}
                                        </p>
                                    </div>
                                </div>
                            ) : null}
                        </section>
                    </Fragment>
                )
            })}
        </div>
    )
}

export default OverviewTabSection
